import { FormLabel } from "../../../components/forms";

const CenterFormColumnComponent = ({ children, className, ...rest }) =>
    <div className={className || 'col'} {...rest}>
        <FormLabel className="invisible">-</FormLabel>
        {children}
    </div>;

export default CenterFormColumnComponent;